/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import { all, call, put, takeLatest, takeLeading } from "redux-saga/effects";
import * as collectorMgmtAction from "./actions";
import {
  CreateCollector,
  FetchACollectorMgmt,
  FetchCollectorMgmtList,
  FetchACollectorLogs,
  UpdateCollectorMgmt,
  CreateAdFramework,
  FetchsupportedDataPoints,
  CreateCollectorMgmtJira,
  AuthorOrUnauthorDataPoint,
} from "./services";
import { updateCollectorMgmtBO } from "./helper";

export function* collectorMgmtListSaga(action) {
  try {
    const response = yield call(FetchCollectorMgmtList, action.payload);
    /* istanbul ignore if */
    if (response?.data?.success) {
      yield put(
        collectorMgmtAction.CollectorMgmtListSuccess(response?.data.data),
      );
    } else {
      yield put(
        collectorMgmtAction.CollectorMgmtListListFailed(response?.data),
      );
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(collectorMgmtAction.CollectorMgmtListListFailed(error));
  }
}
export function* FetchACollectorLogsSaga(action) {
  try {
    const response = yield call(FetchACollectorLogs, action.payload);
    /* istanbul ignore if */
    if (response && response.data && response.data.success) {
      yield put(collectorMgmtAction.FetchACollectorLogsSuccess(response.data));
    } else {
      yield put(collectorMgmtAction.FetchACollectorLogsFailed(response.data));
    }
  } catch (error) {
    yield put(collectorMgmtAction.FetchACollectorLogsFailed(error));
  }
}
export function* fetchAcollectorMgmtSaga(action) {
  try {
    const response = yield call(FetchACollectorMgmt, action.payload);
    /* istanbul ignore if */
    if (response?.data?.success) {
      const data = response?.data?.data;
      const collectorKey = data?.collectorKey || data?.key;
      const imageUrl = `${window.location.origin}/images/collectors-player/${collectorKey}.svg`;
      let collectorImage = null;
      try {
        const imageResponse = yield call(fetch, imageUrl, {
          method: "HEAD",
        });
        if (
          imageResponse.ok &&
          imageResponse.headers.get("content-type")?.includes("image")
        ) {
          collectorImage = imageUrl;
        }
      } catch (_) {
        collectorImage = null;
      }
      yield put(
        collectorMgmtAction.FetchACollectorMgmtSuccess(
          { ...data, collectorImage },
          action.payload,
        ),
      );
    } else {
      yield put(collectorMgmtAction.FetchACollectorMgmtFailed(response?.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(collectorMgmtAction.FetchACollectorMgmtFailed(error));
  }
}
export function* CreateCollectorMgmtJiraSaga(action) {
  try {
    const response = yield call(CreateCollectorMgmtJira, action.payload);
    /* istanbul ignore if */
    if (response && response.data && response.data.success) {
      yield put(
        collectorMgmtAction.CreateCollectorMgmtJiraSuccess(response.data),
      );
    } else {
      yield put(
        collectorMgmtAction.CreateCollectorMgmtJiraFailed(response.data),
      );
    }
  } catch (error) {
    const message =
      error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : error;
    yield put(collectorMgmtAction.CreateCollectorMgmtJiraFailed(message));
  }
}
export function* createCollectorSaga(action) {
  try {
    const response = yield call(CreateCollector, action.payload);
    /* istanbul ignore if */
    if (response.data && response.data.success) {
      const successResponse = {
        data: response.data,
        type: action.payload.type,
      };
      yield put(collectorMgmtAction.CreateCollectorSuccess(successResponse));
    } else {
      const errorResponse = {
        success: response?.data?.success,
        message: response?.data?.message,
      };
      yield put(collectorMgmtAction.CreateCollectorFailed(errorResponse));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(collectorMgmtAction.CreateCollectorFailed(error));
  }
}
export function* updateCollectorMgmtSaga(action) {
  try {
    const response = yield call(UpdateCollectorMgmt, action.payload);
    /* istanbul ignore if */
    if (response?.data?.success) {
      const updatedData = updateCollectorMgmtBO(
        action.payload,
        response?.data?.data,
      );
      yield put(collectorMgmtAction.UpdateCollectorMgmtSuccess(updatedData));
    } else {
      yield put(collectorMgmtAction.UpdateCollectorMgmtFailed(response?.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(collectorMgmtAction.UpdateCollectorMgmtFailed(error));
  }
}
export function* createAdFrameworkSaga(action) {
  try {
    const response = yield call(CreateAdFramework, action.payload);
    /* istanbul ignore if */
    if (response?.data?.success) {
      yield put(collectorMgmtAction.CreateAdFrameworkSuccess(response?.data));
    } else {
      yield put(collectorMgmtAction.CreateAdFrameworkFailed(response?.data));
    }
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(collectorMgmtAction.CreateAdFrameworkFailed(error));
  }
}
export function* FetchsupportedDataPointsSaga(action) {
  /* istanbul ignore next */
  try {
    const response = yield call(FetchsupportedDataPoints, action.payload);
    /* istanbul ignore if */
    if (response?.data?.success) {
      yield put(
        collectorMgmtAction.FetchSupportedDataPointsSuccess(
          response?.data?.data,
        ),
      );
    } else {
      yield put(
        collectorMgmtAction.FetchSupportedDataPointsFailed(
          response?.data?.errors,
        ),
      );
    }
    /* istanbul ignore next */
  } catch (error) {
    yield put(collectorMgmtAction.FetchSupportedDataPointsFailed(error));
  }
}

export function* FetchMoresupportedDataPointsSaga(action) {
  /* istanbul ignore next */
  try {
    const response = yield call(FetchsupportedDataPoints, action.payload);
    /* istanbul ignore if */
    if (response?.data?.success) {
      yield put(
        collectorMgmtAction.FetchMoreSupportedDataPointsSuccess(
          response?.data?.data,
        ),
      );
    } else {
      yield put(
        collectorMgmtAction.FetchMoreSupportedDataPointsFailed(
          response?.data?.errors,
        ),
      );
    }
    /* istanbul ignore next */
  } catch (error) {
    yield put(collectorMgmtAction.FetchMoreSupportedDataPointsFailed(error));
  }
}

export function* CreateMediaPlayerSaga(action) {
  try {
    const response = yield call(CreateAdFramework, action.payload);
    /* istanbul ignore if */
    if (response?.data?.success) {
      yield put(collectorMgmtAction.CreateMediaPlayerSuccess(response?.data));
    } else {
      yield put(collectorMgmtAction.CreateMediaPlayerFailed(response?.data));
    }
  } catch (error) {
    yield put(collectorMgmtAction.FetchMoreSupportedDataPointsFailed(error));
  }
}

export function* FetchsupportedDataPointsOverlaySaga(action) {
  /* istanbul ignore next */
  try {
    const response = yield call(FetchsupportedDataPoints, action.payload);
    /* istanbul ignore if */
    if (response?.data?.success) {
      yield put(
        collectorMgmtAction.FetchSupportedDataPointsSuccessOverlay(
          response?.data?.data,
        ),
      );
    } else {
      yield put(
        collectorMgmtAction.FetchSupportedDataPointsFailedOverlay(
          response?.data?.errors,
        ),
      );
    }
    /* istanbul ignore next */
  } catch (error) {
    yield put(collectorMgmtAction.FetchSupportedDataPointsFailedOverlay(error));
  }
}

export function* FetchMoresupportedDataPointsOverlaySaga(action) {
  /* istanbul ignore next */
  try {
    const response = yield call(FetchsupportedDataPoints, action.payload);
    /* istanbul ignore if */
    if (response?.data?.success) {
      yield put(
        collectorMgmtAction.FetchMoreSupportedDataPointsSuccessOverlay(
          response?.data?.data,
        ),
      );
    } else {
      yield put(
        collectorMgmtAction.FetchMoreSupportedDataPointsFailedOverlay(
          response?.data?.errors,
        ),
      );
    }
    /* istanbul ignore next */
  } catch (error) {
    yield put(
      collectorMgmtAction.FetchMoreSupportedDataPointsFailedOverlay(error),
    );
  }
}

export function* AuthorOrUnauthorDataPointSaga(action) {
  /* istanbul ignore next */
  try {
    const response = yield call(AuthorOrUnauthorDataPoint, action.payload);
    /* istanbul ignore if */
    if (response?.data?.success) {
      yield put(
        collectorMgmtAction.AuthorOrUnAuthorADataPointSuccess(response?.data),
      );
    } else {
      yield put(
        collectorMgmtAction.AuthorOrUnAuthorADataPointFailed(response?.data),
      );
    }
    /* istanbul ignore next */
  } catch (error) {
    yield put(collectorMgmtAction.AuthorOrUnAuthorADataPointFailed(error));
  }
}

export function* collectorMgmtWatcher() {
  yield all([
    takeLatest(
      collectorMgmtAction.types.COLLECTOR_MANAGEMENT_LIST,
      collectorMgmtListSaga,
    ),
    takeLatest(
      collectorMgmtAction.types.FETCH_A_COLLECTOR_LOGS,
      FetchACollectorLogsSaga,
    ),
    takeLeading(
      collectorMgmtAction.types.FETCH_A_COLLECTOR_MANAGEMENT,
      fetchAcollectorMgmtSaga,
    ),
    takeLatest(
      collectorMgmtAction.types.CREATE_COLLECTOR_MANAGEMENT_JIRA,
      CreateCollectorMgmtJiraSaga,
    ),
    takeLatest(collectorMgmtAction.types.CREATE_COLLECTOR, createCollectorSaga),
    takeLeading(
      collectorMgmtAction.types.UPDATE_COLLECTOR_MANAGEMENT,
      updateCollectorMgmtSaga,
    ),
    takeLatest(
      collectorMgmtAction.types.CREATE_AD_FRAMEWORK,
      createAdFrameworkSaga,
    ),
    takeLatest(
      collectorMgmtAction.types.FETCH_SUPPORTED_DATA_POINTS,
      FetchsupportedDataPointsSaga,
    ),
    takeLatest(
      collectorMgmtAction.types.FETCH_MORE_SUPPORTED_DATA_POINTS,
      FetchMoresupportedDataPointsSaga,
    ),
    takeLatest(
      collectorMgmtAction.types.CREATE_MEDIAPLAYER,
      CreateMediaPlayerSaga,
    ),
    takeLatest(
      collectorMgmtAction.types.FETCH_SUPPORTED_DATA_POINTS_OVERLAY,
      FetchsupportedDataPointsOverlaySaga,
    ),
    takeLatest(
      collectorMgmtAction.types.FETCH_MORE_SUPPORTED_DATA_POINTS_OVERLAY,
      FetchMoresupportedDataPointsOverlaySaga,
    ),
    takeLatest(
      collectorMgmtAction.types.AUTHORED_UNAUTHORED_DATAPOINT,
      AuthorOrUnauthorDataPointSaga,
    ),
  ]);
}
